"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchHotelRoomRatesByDate = void 0;
const orders_1 = require("../orders");
const fetchHotelContracts_1 = require("./fetchHotelContracts");
const getHotelRoomAvailability_1 = require("./getHotelRoomAvailability");
const fetchHotelRoomRatesByDate = async (supabase, hotel_id, check_in_date, number_of_nights, contract_type) => {
    const date_ranges = (0, orders_1.getDateRange)(check_in_date, number_of_nights);
    const contracts = await (0, fetchHotelContracts_1.fetchHotelContracts)(supabase, check_in_date, number_of_nights, hotel_id);
    const availaility = (0, getHotelRoomAvailability_1.getHotelRoomAvailability)(date_ranges, contracts, contract_type);
    return availaility;
};
exports.fetchHotelRoomRatesByDate = fetchHotelRoomRatesByDate;
